import React from 'react';
import PersonIcon from '../../../images/person.svg';
var IconPerson = function () { return React.createElement("img", { alt: "personicon", style: { marginRight: '8px' }, src: PersonIcon }); };
export default IconPerson;
